/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Tenantcolor1Inputs */

const en_entity_tenantcolor1 = /** @type {(inputs: Entity_Tenantcolor1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant Color`)
};

const de_entity_tenantcolor1 = /** @type {(inputs: Entity_Tenantcolor1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandantenfarbe`)
};

/**
* | output |
* | --- |
* | "Tenant Color" |
*
* @param {Entity_Tenantcolor1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_tenantcolor1 = /** @type {((inputs?: Entity_Tenantcolor1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Tenantcolor1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_tenantcolor1(inputs)
	return de_entity_tenantcolor1(inputs)
});
export { entity_tenantcolor1 as "entity_tenantColor" }